import {
    AUTOMATION_PATH,
    AUTOMATIONS_PATH,
    CHAT_PATH,
    CONVERSATION_PATH,
    PROJECT_PATH,
    PROJECTS_PATH,
    PROMPT_LIBRARY_PATH,
} from './constants.ts';
import ChatPage from './pages/ChatPage.tsx';
import PromptLibraryPage from './pages/PromptLibraryPage.tsx';

// no agents-enabled condition: the page itself shows a contact-sales teaser when the feature is not activated
export default [
    {
        path: CHAT_PATH,
        component: ChatPage,
    },
    {
        path: CONVERSATION_PATH,
        component: ChatPage,
    },
    {
        path: PROMPT_LIBRARY_PATH,
        component: PromptLibraryPage,
    },
    // static segments win over /chat/:conversationId, so these never collide with a conversation id
    {
        path: PROJECTS_PATH,
        component: ChatPage,
    },
    {
        path: PROJECT_PATH,
        component: ChatPage,
    },
    {
        path: AUTOMATIONS_PATH,
        component: ChatPage,
    },
    {
        path: AUTOMATION_PATH,
        component: ChatPage,
    },
];
